module.exports = __webpack_public_path__ + "static/scale-model-of-creekmont-west-park-in-round-rock-texas-a48adf3bc2813fb9a5c29407f3e19d35.png";